export class ExpenseCategory {
constructor() {
this.id = null;
this.name = '';
this.code = '';
this.remarks='',
this.is_active=false;
}

}
